import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';

export default class MediaQueryEnhancer extends Enhancer {

    init() {

        if (this.enabled) {
            this.mediaQueryList.addListener(this.statusChanged.bind(this));
        }

        if (this.enabled && this.mediaQueryList.matches) {
            this.statusChanged(this.mediaQueryList);
        }

    }

    // Called when media query state changes and on init
    // To be overridden by extending Enhancer
    statusChanged(mq) {
        
    }

    get enabled() {
        if (this.getData('enabled') !== 'false') {
            return true;
        }

        return false;
    }

    set enabled(value) {
        this.setData('enabled', value);
    }

    get mediaQuery() {
        return this.getData('media-query');
    }

    mediaQueryList = window.matchMedia(this.mediaQuery);

}

EnhancerApp.register('MediaQueryEnhancer', MediaQueryEnhancer);